var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8916 4.10872C15.6749 3.89206 15.3916 3.77539 15.0916 3.77539L7.12491 3.79206C6.66658 3.79206 6.29158 4.16706 6.29158 4.62539C6.29158 5.08372 6.66658 5.45872 7.12491 5.45872H13.3749L4.10825 14.7087C3.78325 15.0337 3.78325 15.5587 4.10825 15.8837C4.27492 16.0504 4.48324 16.1254 4.69991 16.1254C4.91658 16.1254 5.12492 16.0421 5.29158 15.8837L14.5582 6.62539V12.8754C14.5499 13.3337 14.9166 13.7087 15.3833 13.7087C15.8416 13.7087 16.2166 13.3337 16.2166 12.8754L16.2333 4.90872C16.2333 4.60872 16.1166 4.31706 15.9083 4.10872H15.8916Z",
    fill: "#E76F51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRight);
export default __webpack_public_path__ + "static/media/arrow-up-right.161517b75809944e8abc76da90aac7cd.svg";
export { ForwardRef as ReactComponent };